<script>
    import { createEventDispatcher } from 'svelte';
    import { slide } from 'svelte/transition';
    import { Tooltip } from 'sveltestrap';

    const dispatch = createEventDispatcher();

    export let list;
    export let label;
    export let idProperty;
    export let nameProperty;
    export let iconProperty = null;
    export let classes = "";
    
    let isListOpen = false;
    let searchString = "";
    let searchBox;

    $: filteredList = list.filter(listItem => ((String(listItem[nameProperty]).toLowerCase()).includes(searchString.toLowerCase())));
    $: checkedCount = list.filter(t => t.checked).length;
    
    function toggleDropdown() {
        if (isListOpen) {
            let checkedList = list.filter(t => t.checked);
            let selectedString = "";
            
            if (checkedList.length > 0) {
                selectedString = checkedList.map(listItem => {return listItem[idProperty]}).join();
            }

            searchString = "";

            dispatch('close', { selectedItems: selectedString });
        } 
        
        isListOpen = !isListOpen;
    }

    function clearChecked() {
        list.forEach(li => {
            li.checked = false;
        });

        list = list;
    }
</script>

<style>
    .dropdown {
        display: inline-block;
    }

    .dropdown-menu {
        display: block;
        z-index: 1034;
        min-width: 200px;
        left: -1px;
        padding: 0;
        margin: 0;
        font-size: 13px;
    }

    .dropdown-menu-header {
        display: flex;
        align-items: center;
        padding: 5px;
        border-bottom: 1px solid rgba(0,0,0,.15);
    }

    .dropdown-menu-header input {
        font-size: 13px;
        width: 100%;
    }

    .dropdown-menu-header input:focus {
       box-shadow: none;
    }

    .dropdown-menu-list {
        max-height: 400px;
        overflow-y: auto;
    }

    .dropdown-item {
        display: flex;
        align-items: center;
        cursor: pointer;    
        padding: 5px;
        color: #212529;
    }

    .dropdown-item-icon {
        padding-left: 4px;
        padding-right: 9px;
    }

    .dropdown-item:hover, .dropdown-item:active, .dropdown-item.active {
        background-color: #edf3f7;
    }

    .dropdown-item input[type=checkbox], .dropdown-item label {
        cursor: pointer;
        margin: 0;
        padding: 0;
    }

    .dropdown-item .dropdown-item-label-no-icon {
        padding-left: 25px;
    }

    .dropdown-item input[type=checkbox] {
        width: 14px;
        height: 14px;
    }

    .dropdown-container {
        position: fixed;
        z-index: 1033;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        cursor: default;
    }

    .clear-btn {
        margin: 0 5px 0 0;
        min-width: 28px;
        padding: 2px 0 2px 0;
    }

    .clear-img {
        height: 18px;
    }

    .clear-btn:hover {
        background-color: #bad1e0;
    }
</style>    

<div class="dropdown {classes}">
    <button type="button" on:click="{toggleDropdown}" 
        class="btn dropdown-toggle text-center" 
        class:btn-outline-primary={checkedCount == 0}
        class:btn-primary={checkedCount > 0}>
        {label} {#if checkedCount > 0}[{checkedCount}]{/if}
    </button>
    {#if isListOpen}
        <div in:slide={{ duration: 150 }} class="dropdown-menu" 
                on:introend="{() => {searchBox.focus()}}">
            <div class="dropdown-menu-header">
                {#if checkedCount > 0}
                    <button id="clear-button" class="btn clear-btn" on:click="{clearChecked}">
                        <img src="/assets/x-circle-fill.svg" alt="Clear selected filters" class="clear-img"/>
                    </button>
                    <Tooltip target="clear-button" placement="bottom">Deselect all</Tooltip>
                {/if}
                <input bind:value={searchString} bind:this={searchBox} class="form-control form-control-sm"
                    placeholder="Search..." />
            </div>
            <div class="dropdown-menu-list">
                {#each filteredList as listItem}
                    <div on:click={() => {listItem.checked = !listItem.checked; list = list}}
                            on:keydown={() => {listItem.checked = !listItem.checked; list = list}}
                            class="dropdown-item" class:active={listItem.checked}>
                        <input bind:checked={listItem.checked} on:keydown|stopPropagation={(e) => {if (e.key == "Escape" || e.key == "Enter") toggleDropdown()}} 
                                id="{label}-{listItem[idProperty]}" type="checkbox" class="mr-2">
                        {#if iconProperty && listItem[iconProperty]}
                            <img id="{label}-{listItem[idProperty]}-icon" class="dropdown-item-icon" src="/assets/{listItem[iconProperty]}.svg" alt="{label} icon">
                        {/if}
                        <label on:click={() => {listItem.checked = !listItem.checked; list = list}}
                                on:keydown={() => {listItem.checked = !listItem.checked; list = list}}
                                class:dropdown-item-label-no-icon={iconProperty && !listItem[iconProperty]} for="{label}-{listItem[idProperty]}">
                            {listItem[nameProperty]}
                        </label>
                    </div>
                {/each}
            </div>
        </div>
    {/if}
</div>

{#if isListOpen}
    <button class="button-reset dropdown-container" on:click={toggleDropdown}></button>
{/if}
